import { useState } from 'react'
import { IGetUsersPayload } from 'src/app/shared/models/accountSetup.model'
import { getDataUsers } from 'src/app/shared/services/AccountService'

export const useUserForAccount = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [userList, setUserList] = useState<Array<any>>([])
  const [totalRecords, setTotalRecords] = useState(0)

  const getUserListData = async (params: IGetUsersPayload, accountId?: string) => {
    try {
      setIsLoading(true)
      const data = await getDataUsers(params, accountId)
      setUserList(
        data?.data?.items?.map((item: any) => ({
          ...item,
        })),
      )
      setTotalRecords(data?.data?.total)
      return data?.data
    } catch (e) {
      console.log('ERROR: ', e)
    } finally {
      setIsLoading(false)
    }
  }

  return { userList, totalRecords, getUserListData, isLoading }
}
